// import React, { useEffect, useState } from "react";
// import {
//   collection,
//   getDocs,
//   orderBy,
//   query,
//   doc,
//   updateDoc,
// } from "firebase/firestore";
// import { db } from "../firebase";
// import { toast, ToastContainer } from "react-toastify";
// import "../css/Report.css";

// // ── Helpers ───────────────────────────────────────────────────────────────────

// const HELP_TYPE_LABELS = {
//   medical: { label: "Medical Help", icon: "🏥", color: "#e74c3c" },
//   education: { label: "Education Help", icon: "🎓", color: "#2980b9" },
//   ration: { label: "Ration Help", icon: "🌾", color: "#f39c12" },
// };

// const STATUS_OPTIONS = ["pending", "in-review", "approved", "rejected"];

// const STATUS_COLORS = {
//   pending: "#f39c12",
//   "in-review": "#2980b9",
//   approved: "#27ae60",
//   rejected: "#e74c3c",
// };

// function DocPreviewThumb({ docKey, docData }) {
//   const [lightbox, setLightbox] = useState(false);
//   const { url, name, resourceType } = docData;

//   const ext = name ? name.split(".").pop().toLowerCase() : "";
//   const isImg =
//     resourceType === "image" ||
//     ["png", "jpg", "jpeg", "webp", "gif"].includes(ext) ||
//     /\.(png|jpg|jpeg|webp|gif)(\?|$)/i.test(url);
//   const isPdf =
//     ext === "pdf" ||
//     /\.pdf(\?|$)/i.test(url) ||
//     (resourceType === "raw" && ext === "pdf");
//   const isDoc = ["doc", "docx"].includes(ext);

//   return (
//     <>
//       <div className="rp-doc-thumb" onClick={() => setLightbox(true)}>
//         {isImg ? (
//           <img src={url} alt={name} className="rp-thumb-img" />
//         ) : isPdf ? (
//           <div className="rp-thumb-icon rp-thumb-pdf">
//             <span>PDF</span>
//           </div>
//         ) : isDoc ? (
//           <div className="rp-thumb-icon rp-thumb-doc">
//             <span>DOC</span>
//           </div>
//         ) : (
//           <div className="rp-thumb-icon rp-thumb-file">
//             <span>FILE</span>
//           </div>
//         )}
//         <p className="rp-thumb-label">{name || docKey}</p>
//       </div>

//       {lightbox && (
//         <div className="rp-lightbox" onClick={() => setLightbox(false)}>
//           <div
//             className="rp-lightbox-inner"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="rp-lightbox-close"
//               onClick={() => setLightbox(false)}
//             >
//               ✕
//             </button>
//             <p className="rp-lightbox-name">{name || docKey}</p>

//             {isImg ? (
//               <img src={url} alt={name} className="rp-lightbox-img" />
//             ) : isPdf ? (
//               <iframe
//                 src={url}
//                 title={name}
//                 className="rp-lightbox-iframe"
//               />
//             ) : (
//               <div className="rp-lightbox-nopreview">
//                 <p>Preview not available for this file type.</p>
//               </div>
//             )}

//             <a
//               href={url}
//               download={name}
//               target="_blank"
//               rel="noreferrer"
//               className="rp-download-btn"
//             >
//               ⬇ Download
//             </a>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// // ── Main Component ────────────────────────────────────────────────────────────

// const Report = () => {
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState("all"); // "all" | "medical" | "education" | "ration"
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [search, setSearch] = useState("");
//   const [expanded, setExpanded] = useState(null); // id of expanded card

//   useEffect(() => {
//     fetchRequests();
//   }, []);

//   const fetchRequests = async () => {
//     setLoading(true);
//     try {
//       const q = query(
//         collection(db, "HelpRequests"),
//         orderBy("date", "desc")
//       );
//       const snap = await getDocs(q);
//       const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       setRequests(data);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to load help requests.");
//     }
//     setLoading(false);
//   };

//   const updateStatus = async (id, newStatus) => {
//     try {
//       await updateDoc(doc(db, "HelpRequests", id), { status: newStatus });
//       setRequests((prev) =>
//         prev.map((r) => (r.id === id ? { ...r, status: newStatus } : r))
//       );
//       toast.success("Status updated.");
//     } catch (err) {
//       toast.error("Failed to update status.");
//     }
//   };

//   const updateBookedBy = async (id, value) => {
//     try {
//       await updateDoc(doc(db, "HelpRequests", id), { bookedBy: value });
//       setRequests((prev) =>
//         prev.map((r) => (r.id === id ? { ...r, bookedBy: value } : r))
//       );
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ── Filtering ──
//   const filtered = requests.filter((r) => {
//     if (filter !== "all" && r.helpType !== filter) return false;
//     if (statusFilter !== "all" && r.status !== statusFilter) return false;
//     if (search) {
//       const s = search.toLowerCase();
//       const name = r.formData?.fullName?.toLowerCase() || "";
//       const phone = r.formData?.phoneNumber?.toLowerCase() || "";
//       if (!name.includes(s) && !phone.includes(s)) return false;
//     }
//     return true;
//   });

//   const formatDate = (ts) => {
//     if (!ts) return "—";
//     const d = ts.toDate ? ts.toDate() : new Date(ts);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // ── Counts ──
//   const counts = {
//     all: requests.length,
//     medical: requests.filter((r) => r.helpType === "medical").length,
//     education: requests.filter((r) => r.helpType === "education").length,
//     ration: requests.filter((r) => r.helpType === "ration").length,
//   };

//   return (
//     <div className="rp-root">
//       <ToastContainer />

//       {/* ── Header ── */}
//       <div className="rp-header">
//         <h2 className="rp-title">Help Requests</h2>
//         <button className="rp-refresh-btn" onClick={fetchRequests}>
//           ↻ Refresh
//         </button>
//       </div>

//       {/* ── Summary Cards ── */}
//       <div className="rp-summary-row">
//         {["all", "medical", "education", "ration"].map((type) => {
//           const info =
//             type === "all"
//               ? { label: "All Requests", icon: "📋", color: "#162f06" }
//               : HELP_TYPE_LABELS[type];
//           return (
//             <button
//               key={type}
//               className={`rp-summary-card ${filter === type ? "rp-summary-active" : ""}`}
//               style={{ "--accent": info.color }}
//               onClick={() => setFilter(type)}
//             >
//               <span className="rp-summary-icon">{info.icon}</span>
//               <span className="rp-summary-count">{counts[type]}</span>
//               <span className="rp-summary-label">{info.label}</span>
//             </button>
//           );
//         })}
//       </div>

//       {/* ── Filters ── */}
//       <div className="rp-filters-row">
//         <input
//           className="rp-search"
//           type="text"
//           placeholder="Search by name or phone…"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//         <select
//           className="rp-status-filter"
//           value={statusFilter}
//           onChange={(e) => setStatusFilter(e.target.value)}
//         >
//           <option value="all">All Statuses</option>
//           {STATUS_OPTIONS.map((s) => (
//             <option key={s} value={s}>
//               {s.charAt(0).toUpperCase() + s.slice(1)}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* ── List ── */}
//       {loading ? (
//         <div className="rp-loading">
//           <div className="rp-loading-spinner"></div>
//           <p>Loading requests…</p>
//         </div>
//       ) : filtered.length === 0 ? (
//         <div className="rp-empty">
//           <span className="rp-empty-icon">📭</span>
//           <p>No help requests found.</p>
//         </div>
//       ) : (
//         <div className="rp-list">
//           {filtered.map((req) => {
//             const typeInfo = HELP_TYPE_LABELS[req.helpType] || {
//               label: req.helpType,
//               icon: "❓",
//               color: "#999",
//             };
//             const isOpen = expanded === req.id;
//             const fd = req.formData || {};
//             const docs = req.documents || {};

//             return (
//               <div
//                 key={req.id}
//                 className={`rp-card ${isOpen ? "rp-card-open" : ""}`}
//               >
//                 {/* ── Card Header ── */}
//                 <div
//                   className="rp-card-header"
//                   onClick={() => setExpanded(isOpen ? null : req.id)}
//                 >
//                   <div className="rp-card-left">
//                     <span
//                       className="rp-type-badge"
//                       style={{ background: typeInfo.color }}
//                     >
//                       {typeInfo.icon} {typeInfo.label}
//                     </span>
//                     <div className="rp-card-name">
//                       {fd.fullName || "—"}
//                     </div>
//                     <div className="rp-card-sub">
//                       {fd.phoneNumber} &nbsp;·&nbsp; {formatDate(req.date)}
//                     </div>
//                     {req.helpType === "medical" && req.patientName && (
//                       <div className="rp-patient-tag">
//                         Patient: {req.patientName}
//                       </div>
//                     )}
//                   </div>
//                   <div className="rp-card-right">
//                     <span
//                       className="rp-status-dot"
//                       style={{ background: STATUS_COLORS[req.status] || "#999" }}
//                     ></span>
//                     <span className="rp-status-text">
//                       {req.status || "pending"}
//                     </span>
//                     <span className="rp-chevron">{isOpen ? "▲" : "▼"}</span>
//                   </div>
//                 </div>

//                 {/* ── Card Body ── */}
//                 {isOpen && (
//                   <div className="rp-card-body">
//                     {/* Personal Info */}
//                     <div className="rp-section">
//                       <h4 className="rp-section-title">Personal Information</h4>
//                       <div className="rp-info-grid">
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Full Name</span>
//                           <span className="rp-info-val">{fd.fullName || "—"}</span>
//                         </div>
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Phone</span>
//                           <span className="rp-info-val">{fd.phoneNumber || "—"}</span>
//                         </div>
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Address</span>
//                           <span className="rp-info-val">{fd.address || "—"}</span>
//                         </div>
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Qualification</span>
//                           <span className="rp-info-val">{fd.qualification || "—"}</span>
//                         </div>
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Occupation</span>
//                           <span className="rp-info-val">{fd.occupation || "—"}</span>
//                         </div>
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Monthly Income</span>
//                           <span className="rp-info-val">
//                             ₹{fd.familyMonthlyIncome || "—"}
//                           </span>
//                         </div>
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Rent Status</span>
//                           <span className="rp-info-val">{fd.rentStatus || "—"}</span>
//                         </div>
//                         <div className="rp-info-item">
//                           <span className="rp-info-key">Family Members</span>
//                           <span className="rp-info-val">
//                             {fd.totalFamilyMembers || 0}
//                           </span>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Family Members List */}
//                     {fd.familyMembers && fd.familyMembers.length > 0 && (
//                       <div className="rp-section">
//                         <h4 className="rp-section-title">Family Members</h4>
//                         <table className="rp-family-table">
//                           <thead>
//                             <tr>
//                               <th>#</th>
//                               <th>Name</th>
//                               <th>Age</th>
//                               <th>Relation</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {fd.familyMembers.map((m, i) => (
//                               <tr key={i}>
//                                 <td>{i + 1}</td>
//                                 <td>{m.name}</td>
//                                 <td>
//                                   {m.age} {m.years}
//                                 </td>
//                                 <td>{m.relation}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {/* Previous Help */}
//                     <div className="rp-section">
//                       <h4 className="rp-section-title">Previous Help</h4>
//                       <p>
//                         <strong>Received before:</strong> {fd.otherHelp || "—"}
//                       </p>
//                       {fd.otherHelp === "Yes" && (
//                         <p>
//                           <strong>Details:</strong>{" "}
//                           {fd.otherHelpDetails || "—"}
//                         </p>
//                       )}
//                     </div>

//                     {/* Documents */}
//                     {Object.keys(docs).length > 0 && (
//                       <div className="rp-section">
//                         <h4 className="rp-section-title">
//                           Uploaded Documents ({Object.keys(docs).length})
//                         </h4>
//                         <div className="rp-docs-grid">
//                           {Object.entries(docs).map(([key, docData]) => (
//                             <DocPreviewThumb
//                               key={key}
//                               docKey={key}
//                               docData={docData}
//                             />
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Admin Controls */}
//                     <div className="rp-section rp-admin-controls">
//                       <h4 className="rp-section-title">Admin Controls</h4>
//                       <div className="rp-controls-row">
//                         <div className="rp-control-group">
//                           <label className="rp-ctrl-label">Status</label>
//                           <select
//                             className="rp-status-select"
//                             value={req.status || "pending"}
//                             onChange={(e) =>
//                               updateStatus(req.id, e.target.value)
//                             }
//                           >
//                             {STATUS_OPTIONS.map((s) => (
//                               <option key={s} value={s}>
//                                 {s.charAt(0).toUpperCase() + s.slice(1)}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                         <div className="rp-control-group">
//                           <label className="rp-ctrl-label">Assigned To</label>
//                           <input
//                             type="text"
//                             className="rp-bookedby-input"
//                             placeholder="Volunteer / Member name"
//                             defaultValue={req.bookedBy || ""}
//                             onBlur={(e) =>
//                               updateBookedBy(req.id, e.target.value)
//                             }
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Report;


import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { toast, ToastContainer } from "react-toastify";
import RejectionModal from "../pages/RejectionModal";
import "../css/Report.css";

const HELP_TYPE_LABELS = {
  medical:   { label:"Medical Help",   icon:"🏥", color:"#e74c3c" },
  education: { label:"Education Help", icon:"🎓", color:"#2980b9" },
  ration:    { label:"Ration Help",    icon:"🌾", color:"#f39c12" },
};

const STATUS_OPTIONS = ["pending","in-review","approved","rejected"];
const STATUS_COLORS  = {
  pending:"#f39c12", "in-review":"#2980b9", approved:"#27ae60", rejected:"#e74c3c",
};

function DocPreviewThumb({ docKey, docData }) {
  const [lightbox, setLightbox] = useState(false);
  const { url, name, resourceType } = docData;
  const ext    = name ? name.split(".").pop().toLowerCase() : "";
  const isImg  = resourceType === "image" || ["png","jpg","jpeg","webp","gif"].includes(ext) || /\.(png|jpg|jpeg|webp|gif)(\?|$)/i.test(url);
  const isPdf  = ext === "pdf" || /\.pdf(\?|$)/i.test(url) || (resourceType === "raw" && ext === "pdf");
  const isDoc  = ["doc","docx"].includes(ext);

  return (
    <>
      <div className="rp-doc-thumb" onClick={() => setLightbox(true)}>
        {isImg ? (
          <img src={url} alt={name} className="rp-thumb-img" />
        ) : isPdf ? (
          <div className="rp-thumb-icon rp-thumb-pdf"><span>PDF</span></div>
        ) : isDoc ? (
          <div className="rp-thumb-icon rp-thumb-doc"><span>DOC</span></div>
        ) : (
          <div className="rp-thumb-icon rp-thumb-file"><span>FILE</span></div>
        )}
        <p className="rp-thumb-label">{name || docKey}</p>
      </div>

      {lightbox && (
        <div className="rp-lightbox" onClick={() => setLightbox(false)}>
          <div className="rp-lightbox-inner" onClick={e => e.stopPropagation()}>
            <button className="rp-lightbox-close" onClick={() => setLightbox(false)}>✕</button>
            <p className="rp-lightbox-name">{name || docKey}</p>
            {isImg ? (
              <img src={url} alt={name} className="rp-lightbox-img" />
            ) : isPdf ? (
              <iframe src={url} title={name} className="rp-lightbox-iframe" />
            ) : (
              <div className="rp-lightbox-nopreview"><p>Preview not available.</p></div>
            )}
            <a href={url} download={name} target="_blank" rel="noreferrer" className="rp-download-btn">⬇ Download</a>
          </div>
        </div>
      )}
    </>
  );
}

const Report = () => {
  const [requests,     setRequests]     = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [filter,       setFilter]       = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [search,       setSearch]       = useState("");
  const [expanded,     setExpanded]     = useState(null);
  const [rejection,    setRejection]    = useState(null);

  useEffect(() => { fetchRequests(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const q    = query(collection(db, "HelpRequests"), orderBy("date", "desc"));
      const snap = await getDocs(q);
      setRequests(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch { toast.error("Failed to load help requests."); }
    setLoading(false);
  };

  const handleStatusChange = (req, newStatus) => {
    if (newStatus === "rejected") {
      const name = req.formData?.fullName || "this request";
      setRejection({ id: req.id, name, pendingStatus: newStatus, helpType: req.helpType });
    } else {
      applyStatus(req.id, newStatus, null);
    }
  };

  const applyStatus = async (id, status, note) => {
    try {
      const update = { status };
      if (note) update.rejectionNote = note;
      await updateDoc(doc(db, "HelpRequests", id), update);
      setRequests(prev => prev.map(r => r.id === id ? { ...r, status, ...(note ? { rejectionNote: note } : {}) } : r));
      toast.success("Status updated.");
    } catch { toast.error("Failed to update status."); }
    setRejection(null);
  };

  const updateBookedBy = async (id, value) => {
    try {
      await updateDoc(doc(db, "HelpRequests", id), { bookedBy: value });
      setRequests(prev => prev.map(r => r.id === id ? { ...r, bookedBy: value } : r));
    } catch (err) { console.error(err); }
  };

  const filtered = requests.filter(r => {
    if (filter !== "all" && r.helpType !== filter) return false;
    if (statusFilter !== "all" && r.status !== statusFilter) return false;
    if (search) {
      const s    = search.toLowerCase();
      const name = r.formData?.fullName?.toLowerCase() || "";
      const phone= r.formData?.phoneNumber?.toLowerCase() || "";
      if (!name.includes(s) && !phone.includes(s)) return false;
    }
    return true;
  });

  const formatDate = ts => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" });
  };

  const counts = {
    all:       requests.length,
    medical:   requests.filter(r => r.helpType === "medical").length,
    education: requests.filter(r => r.helpType === "education").length,
    ration:    requests.filter(r => r.helpType === "ration").length,
  };

  return (
    <div className="rp-root">
      <ToastContainer />
      {rejection && (
        <RejectionModal
          status="rejected"
          itemName={`${rejection.helpType} help request from ${rejection.name}`}
          onConfirm={note => applyStatus(rejection.id, rejection.pendingStatus, note)}
          onCancel={() => setRejection(null)}
        />
      )}

      <div className="rp-header">
        <h2 className="rp-title">Help Requests</h2>
        <button className="rp-refresh-btn" onClick={fetchRequests}>↻ Refresh</button>
      </div>

      <div className="rp-summary-row">
        {["all","medical","education","ration"].map(type => {
          const info = type === "all"
            ? { label:"All Requests", icon:"📋", color:"#162f06" }
            : HELP_TYPE_LABELS[type];
          return (
            <button
              key={type}
              className={"rp-summary-card" + (filter === type ? " rp-summary-active" : "")}
              style={{ "--accent": info.color }}
              onClick={() => setFilter(type)}
            >
              <span className="rp-summary-icon">{info.icon}</span>
              <span className="rp-summary-count">{counts[type]}</span>
              <span className="rp-summary-label">{info.label}</span>
            </button>
          );
        })}
      </div>

      <div className="rp-filters-row">
        <input
          className="rp-search"
          type="text"
          placeholder="Search by name or phone…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select className="rp-status-filter" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          <option value="all">All Statuses</option>
          {STATUS_OPTIONS.map(s => (
            <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="rp-loading"><div className="rp-loading-spinner"/><p>Loading requests…</p></div>
      ) : filtered.length === 0 ? (
        <div className="rp-empty"><span className="rp-empty-icon">📭</span><p>No help requests found.</p></div>
      ) : (
        <div className="rp-list">
          {filtered.map(req => {
            const typeInfo = HELP_TYPE_LABELS[req.helpType] || { label:req.helpType, icon:"❓", color:"#999" };
            const isOpen   = expanded === req.id;
            const fd       = req.formData || {};
            const docs     = req.documents || {};

            return (
              <div key={req.id} className={"rp-card" + (isOpen ? " rp-card-open" : "")}>
                <div className="rp-card-header" onClick={() => setExpanded(isOpen ? null : req.id)}>
                  <div className="rp-card-left">
                    <span className="rp-type-badge" style={{ background: typeInfo.color }}>
                      {typeInfo.icon} {typeInfo.label}
                    </span>
                    <div className="rp-card-name">{fd.fullName || "—"}</div>
                    <div className="rp-card-sub">{fd.phoneNumber} &nbsp;·&nbsp; {formatDate(req.date)}</div>
                    {req.beneficiaryName && (
                      <div className="rp-patient-tag">
                        {req.beneficiaryLabel || "Beneficiary"}: {req.beneficiaryName}
                      </div>
                    )}
                  </div>
                  <div className="rp-card-right">
                    <span className="rp-status-dot" style={{ background: STATUS_COLORS[req.status] || "#999" }}/>
                    <span className="rp-status-text">{req.status || "pending"}</span>
                    <span className="rp-chevron">{isOpen ? "▲" : "▼"}</span>
                  </div>
                </div>

                {isOpen && (
                  <div className="rp-card-body">
                    <div className="rp-section">
                      <h4 className="rp-section-title">Personal Information</h4>
                      <div className="rp-info-grid">
                        <div className="rp-info-item"><span className="rp-info-key">Full Name</span><span className="rp-info-val">{fd.fullName || "—"}</span></div>
                        <div className="rp-info-item"><span className="rp-info-key">Phone</span><span className="rp-info-val">{fd.phoneNumber || "—"}</span></div>
                        <div className="rp-info-item"><span className="rp-info-key">Address</span><span className="rp-info-val">{fd.address || "—"}</span></div>
                        <div className="rp-info-item"><span className="rp-info-key">Qualification</span><span className="rp-info-val">{fd.qualification || "—"}</span></div>
                        <div className="rp-info-item"><span className="rp-info-key">Occupation</span><span className="rp-info-val">{fd.occupation || "—"}</span></div>
                        <div className="rp-info-item"><span className="rp-info-key">Monthly Income</span><span className="rp-info-val">₹{fd.familyMonthlyIncome || "—"}</span></div>
                        <div className="rp-info-item"><span className="rp-info-key">Rent Status</span><span className="rp-info-val">{fd.rentStatus || "—"}</span></div>
                        <div className="rp-info-item"><span className="rp-info-key">Family Members</span><span className="rp-info-val">{fd.totalFamilyMembers || 0}</span></div>
                      </div>
                    </div>

                    {fd.familyMembers && fd.familyMembers.length > 0 && (
                      <div className="rp-section">
                        <h4 className="rp-section-title">Family Members</h4>
                        <table className="rp-family-table">
                          <thead><tr><th>#</th><th>Name</th><th>Age</th><th>Relation</th></tr></thead>
                          <tbody>
                            {fd.familyMembers.map((m, i) => (
                              <tr key={i}>
                                <td>{i+1}</td><td>{m.name}</td>
                                <td>{m.age} {m.years}</td><td>{m.relation}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="rp-section">
                      <h4 className="rp-section-title">Previous Help</h4>
                      <p><strong>Received before:</strong> {fd.otherHelp || "—"}</p>
                      {fd.otherHelp === "Yes" && <p><strong>Details:</strong> {fd.otherHelpDetails || "—"}</p>}
                    </div>

                    {Object.keys(docs).length > 0 && (
                      <div className="rp-section">
                        <h4 className="rp-section-title">Uploaded Documents ({Object.keys(docs).length})</h4>
                        <div className="rp-docs-grid">
                          {Object.entries(docs).map(([key, docData]) => (
                            <DocPreviewThumb key={key} docKey={key} docData={docData} />
                          ))}
                        </div>
                      </div>
                    )}

                    {req.rejectionNote && (
                      <div className="rp-section" style={{background:"#fff5f5", border:"1.5px solid #f5c6c6"}}>
                        <h4 className="rp-section-title" style={{color:"#c0392b"}}>❌ Rejection Note</h4>
                        <p style={{color:"#c0392b", margin:0}}>{req.rejectionNote}</p>
                      </div>
                    )}

                    <div className="rp-section rp-admin-controls">
                      <h4 className="rp-section-title">Admin Controls</h4>
                      <div className="rp-controls-row">
                        <div className="rp-control-group">
                          <label className="rp-ctrl-label">Status</label>
                          <select
                            className="rp-status-select"
                            value={req.status || "pending"}
                            onChange={e => handleStatusChange(req, e.target.value)}
                          >
                            {STATUS_OPTIONS.map(s => (
                              <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
                            ))}
                          </select>
                        </div>
                        <div className="rp-control-group">
                          <label className="rp-ctrl-label">Assigned To</label>
                          <input
                            type="text"
                            className="rp-bookedby-input"
                            placeholder="Volunteer / Member name"
                            defaultValue={req.bookedBy || ""}
                            onBlur={e => updateBookedBy(req.id, e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Report;